export default {
  ChangePassWordMessage: {
    UserNameEmpty: 'Tên đăng nhập không được trống',
    PasswordEmpty: 'Mật khẩu không được trống',
    ConfirmPasswordEmpty: 'Xác nhận mật khẩu không được trống',
    TokenEmpty: 'Lỗi token',
    MinLenghtPassword: 'lỗi số ký tự của pass dưới 8',
    DigitNotExistPassword: 'lỗi pass word cần chưa số',
    UpperAndLowerNotExistPassword: 'lỗi pass cần chứa cả upper lẫn lower',
    NewPasswordEmpty: 'Mật khẩu mới không được trống',
    ConfirmPasswordInvalid: 'Mật khẩu xác nhận không khớp',
    PasswordInvalid: 'Mật khẩu cũ không chính xác',
    UserNameInvalid: 'Tên đăng nhập không đúng',
    UserNameNotFound: 'Tên đăng nhập không tồn tại'
  }
}
